import { createTemplate } from "@videojs/utils/dom";
//#region src/internal/skins/default-video/template.ts
/** Static template rendered from the finalized VJSC module graph. */
const template = createTemplate(`<media-container class="media-skin media-container video-skin" data-theme="default" data-preset="video">
<slot>
</slot>
<media-poster class="media-poster">
<slot name="poster">
<img alt="" decoding="async" class="media-poster-image">
</img>
</slot>
</media-poster>
<media-buffering-indicator class="media-buffering-indicator">
<media-icon name="spinner" class="media-buffering-indicator-spinner-icon">
</media-icon>
</media-buffering-indicator>
<media-error-dialog class="media-dialog-root">
<media-dialog-backdrop class="media-dialog-backdrop">
</media-dialog-backdrop>
<media-dialog-popup class="media-dialog-popup">
<div class="media-dialog-content">
<media-dialog-title class="media-dialog-title">
</media-dialog-title>
<media-dialog-description class="media-dialog-description">
</media-dialog-description>
</div>
<div class="media-dialog-actions">
<media-dialog-close class="media-button media-dialog-close">
</media-dialog-close>
</div>
</media-dialog-popup>
</media-error-dialog>
<media-controls>
<media-controls-backdrop class="video-controls-backdrop">
</media-controls-backdrop>
<media-controls-content class="video-controls video-controls-content">
<media-tooltip-group>
<media-controls-group class="video-controls-primary">
<media-play-button class="media-button media-play-button" id="vjs-9rf9EhOU-0-trigger">
<media-icon name="restart" class="media-button-icon media-play-button-restart-icon">
</media-icon>
<media-icon name="play" class="media-button-icon media-play-button-play-icon">
</media-icon>
<media-icon name="pause" class="media-button-icon media-play-button-pause-icon">
</media-icon>
</media-play-button>
<media-tooltip trigger="vjs-9rf9EhOU-0-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-mute-button commandfor="vjs-1RHrqfJd-0-popup" class="media-button media-mute-button video-controls-volume-button" id="vjs-9rf9EhOU-0-2-trigger">
<media-icon name="volume-off" class="media-button-icon media-mute-button-off-icon">
</media-icon>
<media-icon name="volume-low" class="media-button-icon media-mute-button-low-icon">
</media-icon>
<media-icon name="volume-high" class="media-button-icon media-mute-button-high-icon">
</media-icon>
</media-mute-button>
<media-tooltip trigger="vjs-9rf9EhOU-0-2-trigger" delay="0" disabled sticky side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-volume-popover open-on-hover delay="200" close-delay="100" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-volume-popover" id="vjs-1RHrqfJd-0-popup">
<media-volume-slider class="media-slider media-volume-slider" thumb-alignment="edge" orientation="vertical">
<media-slider-track class="media-slider-track">
<media-slider-fill class="media-slider-fill">
</media-slider-fill>
</media-slider-track>
<media-slider-thumb class="media-slider-thumb media-volume-slider-thumb">
</media-slider-thumb>
</media-volume-slider>
</media-volume-popover>
<media-controls-group class="video-time-slider-group">
<media-time class="media-time-value video-time-value" type="current">
</media-time>
<media-time-slider class="media-slider media-time-slider">
<media-time-slider-chapters class="media-time-slider-chapters">
<template>
<div class="media-time-slider-chapter">
<media-slider-track class="media-slider-track media-time-slider-chapter-track">
<media-slider-buffer class="media-slider-buffer">
</media-slider-buffer>
<media-slider-fill class="media-slider-fill">
</media-slider-fill>
</media-slider-track>
</div>
</template>
</media-time-slider-chapters>
<media-slider-thumb class="media-slider-thumb media-time-slider-thumb">
</media-slider-thumb>
<media-slider-preview class="media-slider-preview" overflow="visible">
<media-slider-thumbnail class="media-slider-preview-content media-popup-surface media-slider-thumbnail">
<img alt="" aria-hidden="true" decoding="async" class="media-slider-thumbnail-image">
</img>
<media-icon name="spinner" class="media-slider-thumbnail-spinner-icon">
</media-icon>
</media-slider-thumbnail>
<div class="media-slider-preview-content media-time-slider-preview-content">
<media-time-slider-chapter-title class="media-time-slider-chapter-title">
</media-time-slider-chapter-title>
<media-slider-value class="media-time-slider-value" type="pointer">
</media-slider-value>
</div>
</media-slider-preview>
</media-time-slider>
<media-time class="media-time-toggle video-time-value" type="remaining" toggle>
</media-time>
</media-controls-group>
<media-captions-button class="media-button media-captions-button video-controls-captions-button" id="vjs-9rf9EhOU-0-3-trigger">
<media-icon name="captions-off" class="media-button-icon media-captions-button-off-icon">
</media-icon>
<media-icon name="captions-on" class="media-button-icon media-captions-button-on-icon">
</media-icon>
</media-captions-button>
<media-tooltip trigger="vjs-9rf9EhOU-0-3-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<button commandfor="vjs-xwpgvLtj-0-popup" class="media-button media-settings-menu-trigger video-controls-settings-button" id="vjs-9rf9EhOU-0-4-trigger">
<media-icon name="gear" class="media-button-icon media-settings-menu-trigger-icon">
</media-icon>
<media-text class="media-settings-menu-trigger-label" token="menu.settings">Settings</media-text>
</button>
<media-tooltip trigger="vjs-9rf9EhOU-0-4-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-text token="menu.settings">Settings</media-text>
</media-tooltip>
<media-menu side="top" align="center" class="media-popup media-popup-surface media-menu-popup media-menu-resizable-popup" id="vjs-xwpgvLtj-0-popup">
<media-menu-content class="media-menu-content">
<media-menu-item commandfor="vjs-erBQD494-0-content" class="media-menu-trigger-item">
<media-icon name="switches" class="media-menu-trigger-item-icon">
</media-icon>
<media-text token="menu.quality">Quality</media-text>
<span class="media-menu-hint">
<span data-part="value" class="media-menu-hint-label">
</span>
<media-icon name="chevron" class="media-menu-forward-chevron">
</media-icon>
</span>
</media-menu-item>
<media-menu-content class="media-menu-content" id="vjs-erBQD494-0-content">
<media-menu-item class="media-menu-back-item">
<media-icon name="chevron" class="media-menu-back-chevron">
</media-icon>
<media-text token="menu.quality">Quality</media-text>
</media-menu-item>
<media-menu-separator class="media-menu-separator">
</media-menu-separator>
<media-quality-radio-group class="media-menu-radio-group">
<template>
<media-menu-radio-item class="media-menu-radio-item">
<span>
<span data-part="label">
</span>
<sup data-part="tier" class="media-menu-tier">
</sup>
</span>
<span data-part="badge" class="media-menu-badge">
</span>
<media-menu-item-indicator force-mount class="media-menu-item-indicator">
<media-icon name="check" class="media-menu-radio-item-icon">
</media-icon>
</media-menu-item-indicator>
</media-menu-radio-item>
</template>
</media-quality-radio-group>
</media-menu-content>
<media-menu-item commandfor="vjs-WMoek8nz-0-content" class="media-menu-trigger-item">
<media-icon name="speech" class="media-menu-trigger-item-icon">
</media-icon>
<media-text token="menu.audio">Audio</media-text>
<span class="media-menu-hint">
<span data-part="value" class="media-menu-hint-label">
</span>
<media-icon name="chevron" class="media-menu-forward-chevron">
</media-icon>
</span>
</media-menu-item>
<media-menu-content class="media-menu-content" id="vjs-WMoek8nz-0-content">
<media-menu-item class="media-menu-back-item">
<media-icon name="chevron" class="media-menu-back-chevron">
</media-icon>
<media-text token="menu.audio">Audio</media-text>
</media-menu-item>
<media-menu-separator class="media-menu-separator">
</media-menu-separator>
<media-audio-track-radio-group class="media-menu-radio-group">
<template>
<media-menu-radio-item class="media-menu-radio-item">
<span data-part="label">
</span>
<media-menu-item-indicator force-mount class="media-menu-item-indicator">
<media-icon name="check" class="media-menu-radio-item-icon">
</media-icon>
</media-menu-item-indicator>
</media-menu-radio-item>
</template>
</media-audio-track-radio-group>
</media-menu-content>
<media-menu-item commandfor="vjs-1ge1uIVf-0-content" class="media-menu-trigger-item">
<media-icon name="speed" class="media-menu-trigger-item-icon">
</media-icon>
<media-text token="menu.speed">Speed</media-text>
<span class="media-menu-hint">
<span data-part="value" class="media-menu-hint-label">
</span>
<media-icon name="chevron" class="media-menu-forward-chevron">
</media-icon>
</span>
</media-menu-item>
<media-menu-content class="media-menu-content" id="vjs-1ge1uIVf-0-content">
<media-menu-item class="media-menu-back-item">
<media-icon name="chevron" class="media-menu-back-chevron">
</media-icon>
<media-text token="menu.speed">Speed</media-text>
</media-menu-item>
<media-menu-separator class="media-menu-separator">
</media-menu-separator>
<media-playback-rate-radio-group class="media-menu-radio-group">
<template>
<media-menu-radio-item class="media-menu-radio-item">
<span data-part="label">
</span>
<media-menu-item-indicator force-mount class="media-menu-item-indicator">
<media-icon name="check" class="media-menu-radio-item-icon">
</media-icon>
</media-menu-item-indicator>
</media-menu-radio-item>
</template>
</media-playback-rate-radio-group>
</media-menu-content>
<media-menu-item commandfor="vjs-O_DOA8p8-0-content" class="media-menu-trigger-item">
<media-icon name="captions-off" class="media-menu-trigger-item-icon">
</media-icon>
<media-text token="menu.captions">Captions</media-text>
<span class="media-menu-hint">
<span data-part="value" class="media-menu-hint-label">
</span>
<media-icon name="chevron" class="media-menu-forward-chevron">
</media-icon>
</span>
</media-menu-item>
<media-menu-content class="media-menu-content" id="vjs-O_DOA8p8-0-content">
<media-menu-item class="media-menu-back-item">
<media-icon name="chevron" class="media-menu-back-chevron">
</media-icon>
<media-text token="menu.captions">Captions</media-text>
</media-menu-item>
<media-menu-separator class="media-menu-separator">
</media-menu-separator>
<media-captions-radio-group class="media-menu-radio-group">
<template>
<media-menu-radio-item class="media-menu-radio-item">
<span data-part="label">
</span>
<media-menu-item-indicator force-mount class="media-menu-item-indicator">
<media-icon name="check" class="media-menu-radio-item-icon">
</media-icon>
</media-menu-item-indicator>
</media-menu-radio-item>
</template>
</media-captions-radio-group>
</media-menu-content>
</media-menu-content>
</media-menu>
</media-controls-group>
<media-controls-group class="video-controls-secondary">
<media-cast-button class="media-button media-cast-button" id="vjs-9rf9EhOU-0-5-trigger">
<media-icon name="cast-enter" class="media-button-icon media-cast-button-enter-icon">
</media-icon>
<media-icon name="cast-exit" class="media-button-icon media-cast-button-exit-icon">
</media-icon>
</media-cast-button>
<media-tooltip trigger="vjs-9rf9EhOU-0-5-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-airplay-button class="media-button media-airplay-button" id="vjs-9rf9EhOU-0-6-trigger">
<media-icon name="airplay-enter" class="media-button-icon media-airplay-button-enter-icon">
</media-icon>
<media-icon name="airplay-exit" class="media-button-icon media-airplay-button-exit-icon">
</media-icon>
</media-airplay-button>
<media-tooltip trigger="vjs-9rf9EhOU-0-6-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-pip-button class="media-button media-pip-button" id="vjs-9rf9EhOU-0-7-trigger">
<media-icon name="pip-enter" class="media-button-icon media-pip-button-enter-icon">
</media-icon>
<media-icon name="pip-exit" class="media-button-icon media-pip-button-exit-icon">
</media-icon>
</media-pip-button>
<media-tooltip trigger="vjs-9rf9EhOU-0-7-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
<media-fullscreen-button class="media-button media-fullscreen-button" id="vjs-9rf9EhOU-0-8-trigger">
<media-icon name="fullscreen-enter" class="media-button-icon media-fullscreen-button-enter-icon">
</media-icon>
<media-icon name="fullscreen-exit" class="media-button-icon media-fullscreen-button-exit-icon">
</media-icon>
</media-fullscreen-button>
<media-tooltip trigger="vjs-9rf9EhOU-0-8-trigger" side="top" class="media-popup media-popup-safe-area media-popup-transition media-popup-surface media-tooltip">
<media-tooltip-label>
</media-tooltip-label>
<media-tooltip-shortcut class="media-tooltip-shortcut">
</media-tooltip-shortcut>
</media-tooltip>
</media-controls-group>
</media-tooltip-group>
</media-controls-content>
</media-controls>
<media-hotkey keys="Space" action="togglePaused">
</media-hotkey>
<media-hotkey keys="k" action="togglePaused">
</media-hotkey>
<media-hotkey keys="m" action="toggleMuted">
</media-hotkey>
<media-hotkey keys="ArrowRight" action="seekStep">
</media-hotkey>
<media-hotkey keys="ArrowLeft" action="seekStep">
</media-hotkey>
<media-hotkey keys="l" action="seekStep">
</media-hotkey>
<media-hotkey keys="j" action="seekStep">
</media-hotkey>
<media-hotkey keys="ArrowUp" action="volumeStep">
</media-hotkey>
<media-hotkey keys="ArrowDown" action="volumeStep">
</media-hotkey>
<media-hotkey keys="0-9" action="seekToPercent">
</media-hotkey>
<media-hotkey keys="Home" action="seekToPercent" value="0">
</media-hotkey>
<media-hotkey keys="End" action="seekToPercent" value="100">
</media-hotkey>
<media-hotkey keys="&gt;" action="speedUp">
</media-hotkey>
<media-hotkey keys="&lt;" action="speedDown">
</media-hotkey>
<media-hotkey keys="f" action="toggleFullscreen">
</media-hotkey>
<media-hotkey keys="c" action="toggleSubtitles">
</media-hotkey>
<media-hotkey keys="i" action="togglePictureInPicture">
</media-hotkey>
<media-gesture type="tap" action="togglePaused" pointer="mouse" region="center">
</media-gesture>
<media-gesture type="tap" action="toggleControls" pointer="touch">
</media-gesture>
<media-gesture type="doubletap" action="seekStep" region="left">
</media-gesture>
<media-gesture type="doubletap" action="toggleFullscreen" region="center">
</media-gesture>
<media-gesture type="doubletap" action="seekStep" region="right">
</media-gesture>
<media-status-announcer class="media-status-announcer">
</media-status-announcer>
<div class="video-status-indicators">
<media-volume-indicator class="media-indicator media-volume-indicator">
<media-volume-indicator-fill class="media-indicator-content media-volume-indicator-fill">
<media-icon name="volume-high" class="media-volume-indicator-high-icon">
</media-icon>
<media-icon name="volume-low" class="media-volume-indicator-low-icon">
</media-icon>
<media-icon name="volume-off" class="media-volume-indicator-off-icon">
</media-icon>
<media-volume-indicator-value class="media-volume-indicator-value">
</media-volume-indicator-value>
</media-volume-indicator-fill>
</media-volume-indicator>
<media-status-indicator actions="toggleSubtitles,toggleFullscreen,togglePictureInPicture" class="media-indicator media-status-indicator">
<div class="media-indicator-content media-status-indicator-content">
<media-icon name="captions-on" class="media-status-indicator-captions-on-icon">
</media-icon>
<media-icon name="captions-off" class="media-status-indicator-captions-off-icon">
</media-icon>
<media-icon name="fullscreen-enter" class="media-status-indicator-fullscreen-enter-icon">
</media-icon>
<media-icon name="fullscreen-exit" class="media-status-indicator-fullscreen-exit-icon">
</media-icon>
<media-icon name="pip-enter" class="media-status-indicator-pip-enter-icon">
</media-icon>
<media-icon name="pip-exit" class="media-status-indicator-pip-exit-icon">
</media-icon>
<media-status-indicator-value class="media-status-indicator-value">
</media-status-indicator-value>
</div>
</media-status-indicator>
<media-seek-indicator class="media-seek-indicator">
<media-icon name="chevron" class="media-seek-indicator-icon">
</media-icon>
<media-seek-indicator-value class="media-seek-indicator-value">
</media-seek-indicator-value>
</media-seek-indicator>
<media-status-indicator actions="togglePaused" class="media-playback-status-indicator">
<media-icon name="play" class="media-playback-status-indicator-play-icon">
</media-icon>
<media-icon name="pause" class="media-playback-status-indicator-pause-icon">
</media-icon>
</media-status-indicator>
</div>
</media-container>`);
//#endregion
export { template };

//# sourceMappingURL=template.js.map